import type { Properties } from 'interfaces/property';
import type { WorkflowEvent } from 'store/entities/chats/interfaces';

import { getPropertyValue } from './property';

/**
 * Extracts workflow event information from event properties.
 * @param properties Event properties object.
 * @returns WorkflowEvent object with workflowId and executionId, or null if not present.
 */
export function getWorkflowEvent(properties?: Properties): WorkflowEvent | null {
  if (!properties) {
    return null;
  }

  const workflowClientId = getPropertyValue<string>(properties, 'source', 'client_id', undefined);

  if (!workflowClientId) {
    return null;
  }

  const workflowId = getPropertyValue<string>(properties, String(workflowClientId), 'workflow_id', undefined);
  const executionId = getPropertyValue<string>(properties, String(workflowClientId), 'execution_id', undefined);

  if (!workflowId || !executionId || typeof workflowId !== 'string' || typeof executionId !== 'string') {
    return null;
  }

  return {
    workflowId,
    executionId,
  };
}
